export interface AccessTokenUrlResult {
  token: string | null;
  cleanUrl: string | null;
}

export interface AuthHandoffUrlResult {
  accessToken: string | null;
  refreshToken: string | null;
  cleanUrl: string | null;
}

export interface AccessTokenLocation {
  pathname: string;
  search: string;
  hash: string;
}

export function readAuthHandoffFromUrl(
  location: AccessTokenLocation,
): AuthHandoffUrlResult {
  const searchParams = new URLSearchParams(location.search);
  const queryAccessToken =
    searchParams.get("token") ?? searchParams.get("accessToken");
  const queryRefreshToken = searchParams.get("refreshToken");
  const hashResult = readTokensFromHash(location.hash);
  const accessToken = hashResult.accessToken ?? queryAccessToken;
  const refreshToken = hashResult.refreshToken ?? queryRefreshToken;

  if (!accessToken) {
    return { accessToken: null, refreshToken: null, cleanUrl: null };
  }

  searchParams.delete("token");
  searchParams.delete("accessToken");
  searchParams.delete("refreshToken");

  const cleanSearch = searchParams.toString();
  const cleanUrl = [
    location.pathname || "/",
    cleanSearch ? `?${cleanSearch}` : "",
    hashResult.hadToken ? hashResult.cleanHash : location.hash,
  ].join("");

  return { accessToken, refreshToken, cleanUrl };
}

export function readAccessTokenFromUrl(
  location: AccessTokenLocation,
): AccessTokenUrlResult {
  const result = readAuthHandoffFromUrl(location);
  return { token: result.accessToken, cleanUrl: result.cleanUrl };
}

function readTokensFromHash(hash: string): {
  accessToken: string | null;
  refreshToken: string | null;
  hadToken: boolean;
  cleanHash: string;
} {
  if (!hash) {
    return {
      accessToken: null,
      refreshToken: null,
      hadToken: false,
      cleanHash: "",
    };
  }

  const params = new URLSearchParams(hash.replace(/^#/, "").replace(/^\?/, ""));
  const accessToken = params.get("token") ?? params.get("accessToken");
  const refreshToken = params.get("refreshToken");

  if (!accessToken && !refreshToken) {
    return {
      accessToken: null,
      refreshToken: null,
      hadToken: false,
      cleanHash: hash,
    };
  }

  params.delete("token");
  params.delete("accessToken");
  params.delete("refreshToken");

  const cleanHash = params.toString();
  return {
    accessToken,
    refreshToken,
    hadToken: true,
    cleanHash: cleanHash ? `#${cleanHash}` : "",
  };
}
